import { render, staticRenderFns } from "./AdditionalFields.vue?vue&type=template&id=7c089d74"
import script from "./AdditionalFields.vue?vue&type=script&lang=ts"
export * from "./AdditionalFields.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalFields.vue?vue&type=style&index=0&id=7c089d74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports